export default __webpack_public_path__ + "static/4706200-01-583a1e0707b55df2d46027bad002ff6e.webp";